import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const backGuard: CanActivateFn = () => {
	const router = inject(Router);
	const copoUrlRedirect = sessionStorage.getItem('copoUrlRedirect');
	if (copoUrlRedirect) {
		sessionStorage.removeItem('copoUrlRedirect');
		return router.createUrlTree([copoUrlRedirect]);
	}

	return true;
};
